import { render } from "./ParcProfileParcCardGunTable.vue?vue&type=template&id=148cda5b"
import script from "./ParcProfileParcCardGunTable.vue?vue&type=script&lang=js"
export * from "./ParcProfileParcCardGunTable.vue?vue&type=script&lang=js"

import "./ParcProfileParcCardGunTable.vue?vue&type=style&index=0&id=148cda5b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__